// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_5r-0";
export var actionModalContentContainer = "_5r-1";
export var footerContainer = "_5r-3";
export var tagsContainer = "_5r-2";